import styled from 'styled-components'

import breakpoints from '../../constants/ui/breakpoints'

const HowItWorksGroupStyled = styled.div`
  width: 100%;

  .section-one {
    .content {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      width: 52%;

      @media (max-width: ${breakpoints.screenMD}) {
        align-items: center;
        text-align: center;
        width: 100%;
      }
    }

    .img {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 2rem;
      width: 48%;

      @media (max-width: ${breakpoints.screenMD}) {
        width: 80%;
        margin-bottom: 2rem;
      }

      @media (max-width: ${breakpoints.screenSM}) {
        width: 95%;
      }

      &.hide-lg {
        display: none;

        @media (max-width: ${breakpoints.screenMD}) {
          display: flex;
        }
      }

      &.hide-md {
        display: flex;

        @media (max-width: ${breakpoints.screenMD}) {
          display: none;
        }
      }
    }

    .title {
      max-width: 630px;
      margin-bottom: 1.5rem;
    }

    .text {
      max-width: 500px;
    }

    .list {
      display: flex;
      flex-direction: column;
      gap: 1rem;
      margin-bottom: 2.5rem;
      text-align: left;

      @media (max-width: ${breakpoints.screenMD}) {
        margin-bottom: 2rem;
      }
    }

    .list-item {
      display: flex;
      align-items: flex-start;
      gap: 0.5rem;
    }

    .item-icon {
      max-width: 18px;
      width: 100%;
      margin-top: 6px;
    }
  }

  .section-two {
    .title {
      margin-bottom: 1.5rem;
    }

    .text {
      max-width: 900px;
      margin-bottom: 3rem;

      @media (max-width: ${breakpoints.screenMD}) {
        max-width: 80%;
      }

      @media (max-width: ${breakpoints.screenSM}) {
        max-width: 100%;
        margin-bottom: 1.5rem;
      }
    }

    .img {
      max-width: 60%;

      @media (max-width: ${breakpoints.screenMD}) {
        max-width: 80%;
      }

      @media (max-width: ${breakpoints.screenSM}) {
        max-width: 50%;
      }

      &.hide-sm {
        display: block;

        @media (max-width: ${breakpoints.screenSM}) {
          display: none;
        }
      }

      &.hide-lg {
        display: none;

        @media (max-width: ${breakpoints.screenSM}) {
          display: block;
        }
      }
    }
  }

  .section-three {
    .title {
      margin-bottom: 1.5rem;
    }

    .text {
      max-width: 900px;
      margin-bottom: 5rem;

      @media (max-width: ${breakpoints.screenMD}) {
        max-width: 80%;
        margin-bottom: 3rem;
      }

      @media (max-width: ${breakpoints.screenSM}) {
        max-width: 100%;
        margin-bottom: 1.5rem;
      }
    }

    .img {
      max-width: 50%;
      margin-bottom: 5rem;

      @media (max-width: ${breakpoints.screenMD}) {
        max-width: 80%;
        margin-bottom: 3rem;
      }

      @media (max-width: ${breakpoints.screenSM}) {
        max-width: 95%;
        margin-bottom: 1.5rem;
      }

      &.hide-lg {
        display: none;

        @media (max-width: ${breakpoints.screenSM}) {
          display: flex;
        }
      }

      &.hide-sm {
        display: flex;

        @media (max-width: ${breakpoints.screenSM}) {
          display: none;
        }
      }
    }

    .link {
      text-decoration: underline;

      @media (max-width: ${breakpoints.screenSM}) {
        max-width: 340px;
      }
    }
  }

  .section-five {
    .title {
      text-align: center;
    }

    .margin-top-3 {
      margin-top: 3rem;

      @media (max-width: ${breakpoints.screenMD}) {
        margin-top: 0;
      }
    }

    .margin-top-5 {
      margin-top: 5rem;

      @media (max-width: ${breakpoints.screenMD}) {
        margin-top: 2rem;
      }
    }
  }
`

export default HowItWorksGroupStyled
